/* eslint-disable no-param-reassign */

export async function getVideo(file: Blob, video: HTMLVideoElement): Promise<HTMLVideoElement> {
	// eslint-disable-next-line promise/avoid-new
	return new Promise((resolve, reject) => {
		video.preload = 'metadata';

		const blob = new Blob([file], { type: file.type });
		video.src = URL.createObjectURL(blob);

		video.onloadedmetadata = () => resolve(video);
		video.onerror = () => reject(new Error('Error loading video'));
	});
}
